"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _UploadContext = require("./UploadContext");
var _Link = _interopRequireDefault(require("../Link"));
var _ImagePreview = _interopRequireDefault(require("../ImagePreview"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// 获取配置信息
var getInfo = function getInfo(tip, message, sampleImage, preset) {
  var root = 'https://imgcache.qq.com/open_proj/proj_qcloud_v2/platform/src/projects/Account/public/';
  var imgBusinessLicense = "".concat(root, "/business-license.png");
  var imgIdcardBack = "".concat(root, "/idcard-back.png");
  var imgIdcardFront = "".concat(root, "/idcard-front.png");
  var imgStatement = "".concat(root, "/statement.png");
  var infos = {
    'idcard-back': {
      tip: '上传手持国徽面证件',
      message: function message(status) {
        return '上传手持国徽面证件，JPG/PNG/PDF 格式，不超过 5M';
      },
      sampleImage: imgIdcardBack
    },
    'idcard-front': {
      tip: '上传手持人像面证件',
      message: function message(status) {
        return '上传手持人像面证件，JPG/PNG/PDF 格式，不超过 5M';
      },
      sampleImage: imgIdcardFront
    },
    statement: {
      tip: '上传声明函',
      message: function message(status) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u4E0B\u8F7D ", /*#__PURE__*/_react.default.createElement(_Link.default, null, "\u4F01\u4E1A\u58F0\u660E\u51FD"), "\uFF0C\u8FDB\u884C\u586B\u5199\u540E\u4E0A\u4F20\uFF1BJPG/PNG/PDF\u683C\u5F0F\uFF0C\u4E0D\u8D85\u8FC7 5M");
      },
      sampleImage: imgStatement
    },
    'business-license': {
      tip: '上传营业执照/相关资质证照',
      message: function message(status) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "\u4E0A\u4F20\u8425\u4E1A\u6267\u7167\u6216\u76F8\u5173\u8D44\u8D28\u8BC1\u7167\uFF0CJPG/PNG/PDF\u683C\u5F0F\uFF0C\u4E0D\u8D85\u8FC7 5M"), /*#__PURE__*/_react.default.createElement("p", null, "\u65E0\u6CD5\u63D0\u4F9B\u8425\u4E1A\u6267\u7167\uFF1F", /*#__PURE__*/_react.default.createElement(_Link.default, null, "\u67E5\u770B\u8D44\u8D28\u8BC1\u7167\u5217\u8868")));
      },
      sampleImage: imgBusinessLicense
    }
  };
  if (preset && infos[preset]) {
    var info = infos[preset];
    return {
      tip: tip || info.tip,
      message: message || info.message,
      sampleImage: sampleImage || info.sampleImage
    };
  }
  return {
    tip: tip,
    message: message,
    sampleImage: sampleImage
  };
};

// 上传组件
var UploadImage = function UploadImage(props) {
  var _classnames;
  var className = props.className,
    style = props.style,
    image = props.image,
    status = props.status,
    percent = props.percent,
    tip = props.tip,
    message = props.message,
    sampleImage = props.sampleImage,
    preset = props.preset,
    open = props.open,
    abort = props.abort;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('upload-image');
  var _useContext = (0, _react.useContext)(_UploadContext.UploadContext),
    isDragging = _useContext.isDragging,
    getDraggerProps = _useContext.getDraggerProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    preview = _useState2[0],
    setPreview = _useState2[1];
  var closePreview = function closePreview() {
    setPreview(false);
  };
  var openPreview = function openPreview() {
    setPreview(true);
  };
  var classes = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "is-error", !isDragging && status === 'error'), (0, _defineProperty2.default)(_classnames, "is-loading", status === 'validating'), (0, _defineProperty2.default)(_classnames, "".concat(prefixCls, "--has-image"), !isDragging && status !== 'validating' && image), (0, _defineProperty2.default)(_classnames, "is-dragging", isDragging), _classnames));
  var info = getInfo(tip, message, sampleImage, preset);
  var handleClick = function handleClick() {
    if (status === 'validating' && abort) {
      abort();
    }
    if (typeof open === 'function') {
      open();
    }
  };
  var draggerProps = getDraggerProps ? getDraggerProps({
    className: "".concat(prefixCls, "__main")
  }) : {};
  var renderAreaContent = function renderAreaContent() {
    // 上传中
    if (status === 'validating') {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-tip")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-tip-inner")
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "".concat(prefixCls, "__icon loading")
      }), /*#__PURE__*/_react.default.createElement("p", null, "\u4E0A\u4F20\u4E2D", percent !== undefined && percent !== null ? " ".concat(percent, "%") : ''))), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-mask")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-mask-inner")
      }, "\u91CD\u65B0\u4E0A\u4F20")));
    }

    // 有图片状态
    if (image) {
      return isDragging ? /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-tip")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-tip-inner")
      }, "\u91CA\u653E\u9F20\u6807")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__img"),
        style: {
          backgroundImage: "url(".concat(image, ")")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-mask")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__area-mask-inner")
      }, "\u91CD\u65B0\u4E0A\u4F20")));
    }

    // 无图片的默认状态
    return isDragging ? /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__area-tip")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__area-tip-inner")
    }, "\u91CA\u653E\u9F20\u6807")) : /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__area-tip")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__area-tip-inner")
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "".concat(prefixCls, "__icon upload")
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(prefixCls, "__area-tip-primary")
    }, info.tip), /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(prefixCls, "__area-tip-weak")
    }, "\u6216\u62D6\u62FD\u5230\u6B64\u533A\u57DF")));
  };
  var messageContent = info.message ? info.message(status) : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", draggerProps, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__area"),
    onClick: handleClick
  }, renderAreaContent()), info.sampleImage && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__view"),
    onClick: openPreview
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__img")),
    style: {
      backgroundImage: info.sampleImage ? "url(".concat(info.sampleImage, ")") : ''
    }
  })), /*#__PURE__*/_react.default.createElement(_ImagePreview.default.Viewer, {
    visible: preview,
    onClose: closePreview,
    previewSrc: info.sampleImage
  }))), messageContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__msg")
  }, info.message(status)));
};
var _default = exports.default = UploadImage;